export default __webpack_public_path__ + "static/media/step2.2a00c5e3.mp4";